module.exports = __webpack_public_path__ + "media/img/payment-methods/mastercard-6577b45d0ccc76a449b362812bf3c12e.svg";